import { CreditCard, Receipt, Users, WalletCards } from 'lucide-react';

/** English application captures made with the isolated MarketingDemoSeeder. */
export const productTours = [
    { id: 'resident', icon: Users, shot: 'resident-overview-en' },
    { id: 'billing', icon: CreditCard, shot: 'billing-en' },
    { id: 'bank', icon: WalletCards, shot: 'bank-review-en' },
    { id: 'expenses', icon: Receipt, shot: 'expenses-en' },
] as const;

export type ProductTourId = (typeof productTours)[number]['id'];
export const demoImage = (name: string) => `/images/marketing/demo/${name}.webp`;
